export const WORKSHEET_NOT_SAVED_LABEL = 'Not saved yet';

export const WORKSHEET_LAST_SAVED_PREFIX = 'Last saved';

export const WORKSHEET_CHECKLIST_PASSED_SUFFIX = 'passed';

export const WORKSHEET_CHECKLIST_NOT_PASSED_SUFFIX = 'not passed';
